import React from 'react';
import { CCUS_ERROR_FLAG } from '../../../constants/constants';

interface CcusLevelLabelProps {
  ccusLevel: number
  ccusErrorFlag: string
}

export const CcusLevelLabel = (props: CcusLevelLabelProps) => {

  const ccusLevel = props.ccusLevel;
  const ccusErrorFlag = props.ccusErrorFlag;

    let levelLabel = ccusLevel == 4 ? "レベル４（金）" : ccusLevel == 3 ? "レベル３（銀）" : ccusLevel == 2 ? "レベル２（青）" : ccusLevel == 1 ? "レベル１（白）" : "－";
    let errorLabel = "";
    if (ccusErrorFlag === CCUS_ERROR_FLAG.ON) {
      if (levelLabel === "－") {
        levelLabel = "";
      }
      errorLabel = "※エラー";
    }

    return <>{levelLabel}<span style={{ color: "red" }}>{errorLabel}</span></>;
}